import './styles/main';
import { GithubBanner } from './components/github-banner';
import { RuleProfiler } from './components/rule-profiler';

export default function App () {
	return (<div>
		<GithubBanner />
		<div class="container">
			<h1>Rainbird Rule Profiler</h1>
			<RuleProfiler numberFormat={{ locales: 'en-IN', maximumFractionDigits: 2 }} />
		</div>
	</div>);
}



// WEBPACK FOOTER //
// ./index.js